module.exports = __webpack_public_path__ + "static/media/client-logo-white-02.a02af85f.svg";